import { Injectable } from '@angular/core';

import { Point } from '../../models/map/point.model';
import { Vehicle } from '../../models/domain/Vehicle';
import { VehicleControlIndicator } from '../../models/domain/VehicleControlIndicator';
import { VehicleStatusEnum } from '../../models/domain/VehicleStatusEnum';
import { TachoStatusWorker } from '@commons/enums/tacho.enum';

/**
 * Provides mapping utilities
 */
@Injectable()
export class MappingService {

    /**
     * mapowianie czujnika
     * @param remote obiekt zdalny
     */
    public static mapRemoteToVehicleControlIndicator(remote: any, types: any[]): VehicleControlIndicator {

        // mapowienie typu na grupe
        remote.Id = (<any>remote).VehicalControlIndicatorId;

        for (const type of types) {
            if (remote.Tp === type.Type) {
                remote.Group = type.Group;
                break;
            }
        }

        // { Type: 1, Name: 'Adres' },
        // { Type: 2, Name: 'Czas' },
        // { Type: 3, Name: 'Czujniki' },
        // { Type: 4, Name: 'Kierowca' },
        // { Type: 5, Name: 'Licznik km' },
        // { Type: 6, Name: 'Napięcie' },
        // { Type: 8, Name: 'Paliwo' },
        // { Type: 9, Name: 'Paliwo CAN' },
        // { Type: 10, Name: 'Pedał gazu' },
        // { Type: 11, Name: 'Pojazd' },
        // { Type: 12, Name: 'Prędkość' },
        // { Type: 13, Name: 'Status' },
        // { Type: 16, Name: 'Tachograf' },
        // { Type: 17, Name: 'Temperatura' },
        // { Type: 18, Name: 'Zuzycie CAN' },


        // // mapowanie group ui
        // switch (remote.Type) {
        //     // status
        //     case 1000:
        //         remote.Group = 13;
        //         break;
        //     // predkość
        //     case 2:
        //         remote.Group = 12;
        //         break;
        //     // { Type: 14, Name: 'Sygnał GPS' },
        //     case 21:
        //         remote.Group = 14;
        //         break;
        //     // { Type: 15, Name: 'Sygnał GSM' },
        //     case 22:
        //         remote.Group = 15;
        //         break;
        //     // Paliwo CAN
        //     case 1:
        //         remote.Group = 9;
        //         break;
        //     // Licznik kilometrow CAN
        //     case 17:
        //         remote.Group = 5;
        //         break;
        //     // Predkosc CAN
        //     case 2:
        //         remote.Group = 12;
        //         break;
        //     // Kierowca
        //     case 23:
        //         remote.Group = 4;
        //         break;
        //     // Przyspiesznie
        //     case 24:
        //         remote.Group = 10;
        //         break;
        //     // { Type: 7, Name: 'Obroty' },
        //     case 5:
        //         remote.Group = 7;
        //         break;
        //     // Napiecie
        //     case 7:
        //         remote.Group = 6;
        //         break;
        //     // Napiecie
        //     case 6:
        //         remote.Group = 17;
        //         break;


        //     default:
        //         remote.Group = 0;
        //         break;
        // }

        return <VehicleControlIndicator>remote;
    }

    /**
     * konwersja statusow kierowcow
     */
    public static convertDriverStatus(status: number): number {

        // Unknown = 0, // kierowca powiązany z pojazdem ale status pojazdu nieznany
        // Driving = 1, //kierowca powiązany z pojazdem i pojazd jedzie
        // NotDriving = 2, //kierowca powiązany z pojazdem i pojazd stoi
        // NotBound = 3, // kierowca nie powiązany z pojazdem

        switch (status) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            default:
                return 4;
        }
    }


    /**
     * konwersja statusu z tekom na nasz - tacho
     * @param tekomStatus status z tekom
     */
    public static convertTachoStatus(tekomStatus: number) {
        let state: TachoStatusWorker;
        switch (tekomStatus) {
            case 0:
                state = TachoStatusWorker.Rest;
                break;
            case 1:
                state = TachoStatusWorker.Free;
                break;
            case 2:
                state = TachoStatusWorker.Work;
                break;
            case 3:
                state = TachoStatusWorker.Driving;
                break;
            default:
                state = TachoStatusWorker.Free;
                break;
        }
        return state;
    }

    /**
     * Maps vehicles to points for clustering algorithm
     * @param vehicles array of vehicles
     */
    public mapVehiclesToPoints(vehicles: Vehicle[]): Point[] {

        if (!vehicles) {
            return [];
        }

        const points: Point[] = [];

        for (const v of vehicles) {

            // pobranie kierunku
            // dla statusu poruszania sie pojazdu
            let VehicleAngle = 0;
            if (v.St === VehicleStatusEnum.Moving) {
                VehicleAngle = v.VehicleAngle;
            }

            // lokalizacja
            if (v.LL) {

                const lat = parseFloat(('' + v.LL.Lt).replace(',', '.'));
                const lng = parseFloat(('' + v.LL.Ln).replace(',', '.'));

                if (lat && lat !== 361 && lng && lng !== 361) {
                    const point: Point = {
                        lat: (lat),
                        lng: (lng),
                        properties: {
                            Id: v.Id,
                            VehicleStatus: v.St,
                            VehicleName: v.Nm,
                            VehicleAngle: VehicleAngle
                        },
                    };
                    points.push(point);
                }
            }

        }
        return points;
    }



}
